define([
            'underscore',
            'chartjs'
        ],
function (_, Chart) {
    var it = {};
    it.exportHandler = function(chart) {
        var labels = _.map(chart.datasets, function(d) { return d.label; });
        var labelRow = [''].concat(labels);
        
        var labelColumn = chart.scale.xLabels;
        var valueColumns = _.map(chart.datasets, function(d) { return _.map(d.bars||d.points, function(b) { return b.value;}); });
        var allColumns = [labelColumn].concat(valueColumns);
        var rows = _.zip.apply(null, allColumns);
        var allRows = [labelRow].concat(rows);
        var allRowsString = _.map(allRows, function(r) { return r.join(',');}).join('\n');
//        var csvContent = "data:text/csv;charset=UTF-16LE,\xff\xfe" + allRowsString;
        var csvContent = "data:text/csv;charset=utf-8,\uFEFF" + allRowsString;
        var encodedUri = encodeURI(csvContent);
        return encodedUri;
    };

    it.getOrdinalPositionOfEvent = function(chart, evt) {
        var activeDataPoints;
        if(chart.getBarsAtEvent) {
            activeDataPoints = chart.getBarsAtEvent(evt);
        } else if(chart.getPointsAtEvent) {
            activeDataPoints = chart.getPointsAtEvent(evt);
        }
        if(activeDataPoints.length>0) {
            var ret = -1;
            var activeDataPoint = activeDataPoints[0];
            var labels = chart.scale.xLabels;
            var f = _.indexOf(labels, activeDataPoint.label);
            return f;
        }
        return -1;
    };

    it.colors = {
        mauveUno: { solid: "rgb(138,3,140)", transparent: "rgba(138,3,140, 0.7)"},
        blueDue: { solid: "rgb(52,112,191)", transparent: "rgba(52,112,191, 0.7)"},
        greenTre: { solid: "rgb(21,140,17)", transparent: "rgba(21,140,17, 0.7)"},
        peachQuattro: { solid: "rgb(242,135,5)", transparent: "rgba(242,135,5, 0.7)"},
        orangeCinque: { solid: "rgb(217,56,20)", transparent: "rgba(217,56,20, 0.7)"},
        brownSei: { solid: "rgb(50,188,255)", transparent: "rgba(50,188,255, 0.7)"}
    };
    
    return it;
});